// src/utils/config.js - API Configuration

const getApiUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://goldvines.shop';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:30035';
};

export const API_URL = getApiUrl();

const config = {
  API_URL
};

export default config;